import LoanQuoteForm from './components/LoanQuoteForm';

function App({ formType, disableSubmission }) {
    return (
        <div className="container">
            <LoanQuoteForm formType={formType} disableSubmission={disableSubmission}/>
        </div>
    );
}

export default App;
